import React, { useEffect, useState } from 'react';
import { IonButton, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonCheckbox, IonChip, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonImg, IonInput, IonItem, IonList, IonPage, IonProgressBar, IonRange, IonRouterLink, IonRow, IonText, IonTitle, IonToolbar } from '@ionic/react';
import { useParams } from 'react-router';
import { chatbubble, checkmarkCircleOutline } from 'ionicons/icons';
import { informationCircle, videocamOutline,bookOutline , helpOutline} from 'ionicons/icons';
import { count } from 'console';
import { dataJSON } from '../data';
import { Fragen } from '../components/Fragen';

const ModulDyn: React.FC = () => {
  const {  modul} = useParams<{ modul: string}>();

  // Find the index of the current module and get the next module's title
  const currentModulIndex = dataJSON.findIndex(m => 
    m.Überschrift.replaceAll('?"','').replaceAll('?','') === modul || m.Überschrift === modul
  );
  const nextModulTitle = currentModulIndex >= 0 && currentModulIndex < dataJSON.length - 1 
    ? dataJSON[currentModulIndex + 1].Überschrift 
    : null;

function createListe(text:string){
  const items=text.split('!LI!').slice(1);
  return <ul key={Math.random()}>
    {items.map((item:string)=><li  key={Math.random()}>{item}</li>)}
  </ul>
}


function linkify(text: string): React.ReactNode {
  if (!text) return text;
  // erweitert: erkennt optionales http(s) und optionales www sowie bare domains (z. B. example.com)
  const urlRegex = /(?:https?:\/\/)?(?:www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\/[^\s]*)?/g;
  const result: React.ReactNode[] = [];
  let lastIndex = 0;

  const matches = Array.from(text.matchAll(urlRegex));
  for (const match of matches) {
    const matched = match[0];
    const idx = match.index ?? 0;
    if (idx > lastIndex) result.push(text.slice(lastIndex, idx));

    // entferne abschließende Satzzeichen aus dem Match (so bleiben sie außerhalb des <a>)
    const trailingPunctMatch = matched.match(/[.,;:!?]+$/);
    const trailing = trailingPunctMatch ? trailingPunctMatch[0] : '';
    const urlClean = trailing ? matched.slice(0, matched.length - trailing.length) : matched;

    const href = urlClean.startsWith('http') ? urlClean : 'http://' + urlClean;
    result.push(
      <a key={result.length} href={href} target="_blank" rel="noopener noreferrer">
        {urlClean}
      </a>
    );

    // falls es trailing punctuation gab, anhängen
    if (trailing) result.push(trailing);

    // setze lastIndex hinter das vollständige Match (inkl. trailing)
    lastIndex = idx + matched.length;
  }

  if (lastIndex < text.length) result.push(text.slice(lastIndex));
  return result.length ? result : text;
}

function textformatierung(text:string){
  if(text.includes('!LISTEANFANG!')){
    console.log("liste gefunden")
    return (
      text.split('!LISTEANFANG!').map((block:string)=>{
      
        if(block.includes('!LISTEENDE!')){
          console.log(
            "listenenende gefunden"
          )
        return (<>{createListe(block.split('!LISTEENDE!')[0]) }{block.split('!LISTEENDE!')[1]}</>)
      }
      else {
        return linkify(block)
      }
      }))
    }
else {
  return linkify(text);
}
}


  return (
    <IonPage> {
          dataJSON.map((modulData)=>{
            if(modulData.Überschrift.replaceAll('?"','').replaceAll('?','')==modul || modulData.Überschrift==modul){
//              setUsedModul(modulData);
const gültigAbString=new Date(modulData['gueltigAb']).toLocaleDateString('de-DE')
              return (
                <>
      <IonHeader>
        <IonToolbar>
          <IonTitle><IonImg src="logo_lichteMomente.png" style={{float:'left',maxHeight:'5vh',height:"5vh"}}/>{modulData.Modul} {modulData.Überschrift}</IonTitle>
            
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large"><IonImg src="logo_lichteMomente.png" style={{float:'left',maxHeight:'10vh',height:"10vh"}}/>{modulData.Modul} {modulData.Überschrift} </IonTitle>
          </IonToolbar>
        </IonHeader>
        {
          modulData['gueltigAb'] && modulData['gueltigAb'] < new Date().toISOString().split('T')[0] ?
<IonGrid>
        <IonRow>
       
                {
                    modulData['Einleitung'] ?
                  <IonCol key={Math.random()} sizeLg='6' size="6" sizeSm='12' sizeXs='12'>
                    <IonCard style={{ backgroundColor: "" }}>
                      <IonCardHeader>
                        <IonCardTitle>{modulData.Überschrift}</IonCardTitle>
                        <IonCardSubtitle>{modulData.Unterüberschrift}</IonCardSubtitle>
                      </IonCardHeader>
                      <IonCardContent>
                        <p>{textformatierung(modulData.Einleitung)}</p>
                      </IonCardContent>
                    </IonCard>
                  </IonCol>
                   :
                      null
                }
                  {
                    modulData['FallbeispielText1'] ?
                      <IonCol key={Math.random()} sizeLg='6' size="6" sizeSm='12' sizeXs='12'>
                        <IonCard style={{backgroundColor:'lightyellow'}}>
                          <IonCardHeader>
                            <IonCardTitle><IonIcon icon={bookOutline}/> Fallbeispiel<br />&quot;{modulData['FallbeispielTitel1']}&quot;</IonCardTitle>
                          </IonCardHeader>
                          <IonCardContent>
                            <p>{textformatierung(modulData['FallbeispielText1'])}</p>
                          </IonCardContent>
                        </IonCard>
                      </IonCol>
                      :
                      null
                  }
                  {modulData['Modul'] == 'Modul 01' ? 
                  <iframe width="560" height="315" src="https://www.youtube.com/embed/YTD9I5_j-g0?si=ojhQ1AHIfUrxCCiO" title="YouTube video player"  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
                  :null}
                  {
                    modulData['AUFGABE'] ?
                      <IonCol key={Math.random()} sizeLg='6' size="6" sizeSm='12' sizeXs='12'>
                        <IonCard style={{ backgroundColor: "" }}>
                          <IonCardHeader>
                            <IonCardTitle><IonIcon icon={helpOutline} />Zwischenfragen</IonCardTitle>
                          </IonCardHeader>
                          <IonCardContent>

                              <p>{textformatierung(modulData['AUFGABE'])}</p>
                          </IonCardContent>
                        </IonCard>
                      </IonCol>
                      :
                      null
                  }
                  {
                    modulData['Unterüberschrift2'] ?
                      <IonCol key={Math.random()} sizeLg='6' size="6" sizeSm='12' sizeXs='12'>
                        <IonCard style={{ backgroundColor: "" }}>
                          <IonCardHeader>
                            <IonCardTitle>{modulData['Unterüberschrift2']}</IonCardTitle>
                          </IonCardHeader>
                          <IonCardContent>
                              <p>{textformatierung(modulData['Text2'])}  </p>
                          </IonCardContent>
                        </IonCard>
                      </IonCol>
                      :
                      null
                  }
                  {
                    modulData['INFOText'] ?
                    modulData['INFOText'].length>300?
                    modulData['INFOText'].split('!NEUERBLOCK!').map((block)=>
                    {
                      


                      return <IonCol key={Math.random()} sizeLg='6' size="6" sizeSm='12' sizeXs='12'>
                        <IonCard style={{ backgroundColor: "" }}>
                          <IonCardHeader>
                            <IonCardTitle><IonIcon icon={informationCircle}/>&nbsp;INFO<br />{modulData['INFOTitel']}</IonCardTitle>
                          </IonCardHeader>
                          <IonCardContent>
                              <p>{
                              textformatierung(block)
                              
                              }  </p>
                          </IonCardContent>
                        </IonCard>
                      </IonCol>  
                  })

                    :
                      <IonCol key={Math.random()} sizeLg='6' size="6" sizeSm='12' sizeXs='12'>
                        <IonCard style={{ backgroundColor: "" }}>
                          <IonCardHeader>
                            <IonCardTitle><IonIcon icon={informationCircle}/>&nbsp;INFO</IonCardTitle>
                          </IonCardHeader>
                          <IonCardContent>
                              <p>{textformatierung(modulData['INFOText'])}  </p>
                          </IonCardContent>
                        </IonCard>
                      </IonCol>
                      
                      :
                      null
                  }
                  {
                    modulData['DerKonflikt'] ?
                      <IonCol key={Math.random()} sizeLg='6' size="6" sizeSm='12' sizeXs='12'>
                        <IonCard style={{ backgroundColor: "" }}>
                          <IonCardHeader>
                            <IonCardTitle>Der Konflikt</IonCardTitle>
                          </IonCardHeader>
                          <IonCardContent>
                              <p>{textformatierung(modulData['DerKonflikt'])}  </p>
                          </IonCardContent>
                        </IonCard>
                      </IonCol>
                      :
                      null
                  }
                  {
                    modulData['Diskussion1'] ?
                      <IonCol key={Math.random()} sizeLg='6' size="6" sizeSm='12' sizeXs='12'>
                        <IonCard style={{ backgroundColor: "" }}>
                          <IonCardHeader>
                            <IonCardTitle><IonIcon icon={chatbubble}/>Diskussion</IonCardTitle>
                          </IonCardHeader>
                          <IonCardContent>
                              <p>{textformatierung(modulData['Diskussion1'])}  </p>
                          </IonCardContent>
                        </IonCard>
                      </IonCol>
                      :
                      null
                  }
                  {
                    modulData['InfoText1'] ?
                      <IonCol key={Math.random()} sizeLg='6' size="6" sizeSm='12' sizeXs='12'>
                        <IonCard style={{ backgroundColor: "" }}>
                          <IonCardHeader>
                            <IonCardTitle><IonIcon icon={informationCircle}/>&nbsp;INFO {modulData['InfoÜberschrift1']?<><br />{modulData['InfoÜberschrift1']}</> :null}</IonCardTitle>
                           
                          </IonCardHeader>
                          <IonCardContent >
                            <p>{textformatierung(modulData['InfoText1'])}</p>
                          </IonCardContent>
                        </IonCard>
                      </IonCol>
                      :
                      null
                  }
                  {
                    modulData['InfoText2'] ?
                    modulData['InfoText2'].length>300?
                    modulData['InfoText2'].split('!NEUERBLOCK!').map((block)=>
                    {
                      


                      return <IonCol key={Math.random()} sizeLg='6' size="6" sizeSm='12' sizeXs='12'>
                        <IonCard style={{ backgroundColor: "" }}>
                          <IonCardHeader>
                            <IonCardTitle><IonIcon icon={informationCircle}/>&nbsp;INFO {modulData['InfoÜberschrift2']?<><br />{modulData['InfoÜberschrift2']}</> :null}</IonCardTitle>
                          </IonCardHeader>
                          <IonCardContent>
                              <p>{
                              textformatierung(block)
                              
                              }  </p>
                          </IonCardContent>
                        </IonCard>
                      </IonCol>  
                  })

                    :
                      <IonCol key={Math.random()} sizeLg='6' size="6" sizeSm='12' sizeXs='12'>
                        <IonCard style={{ backgroundColor: "" }}>
                          <IonCardHeader>
                            <IonCardTitle><IonIcon icon={informationCircle}/>&nbsp;INFO</IonCardTitle>
                          </IonCardHeader>
                          <IonCardContent>
                              <p>{textformatierung(modulData['InfoText2'])}  </p>
                          </IonCardContent>
                        </IonCard>
                      </IonCol>
                      
                      :
                      null
                  }
                  
                  {
                    modulData['TIPPS'] ?
                      <IonCol key={Math.random()} sizeLg='6' size="6" sizeSm='12' sizeXs='12'>
                        <IonCard style={{backgroundColor:"lightgreen"}}>
                          <IonCardHeader>
                            <IonCardTitle><IonIcon icon={informationCircle}/>&nbsp;TIPP</IonCardTitle>
                          </IonCardHeader>
                          <IonCardContent>
                              <p>{textformatierung(modulData['TIPPS'])}  </p>
                          </IonCardContent>
                        </IonCard>
                      </IonCol>
                      :
                      null
                  }
                  {
                    modulData['FallbeispielText2'] ?
                      <IonCol key={Math.random()} sizeLg='6' size="6" sizeSm='12' sizeXs='12'>
                        <IonCard style={{backgroundColor:'lightyellow'}}>
                          <IonCardHeader>
                            <IonCardTitle><IonIcon icon={bookOutline}/> Fallbeispiel &quot;{modulData['FallbeispielTitel2']}&quot;</IonCardTitle>
                          </IonCardHeader>
                          <IonCardContent>
                            <p>{textformatierung(modulData['FallbeispielText2'])}</p>
                          </IonCardContent>
                        </IonCard>
                      </IonCol>
                      :
                      null
                  }
                  {
                    modulData['Aufgabe2'] ?
                      <IonCol key={Math.random()} sizeLg='6' size="6" sizeSm='12' sizeXs='12'>
                        <IonCard style={{ backgroundColor: "" }}>
                          <IonCardHeader>
                            <IonCardTitle><IonIcon icon={helpOutline}/>Fragen</IonCardTitle>
                          </IonCardHeader>
                          <IonCardContent>
                              <p>{textformatierung(modulData['Aufgabe2'])}  </p>
                          </IonCardContent>
                        </IonCard>
                      </IonCol>
                      :
                      null
                  }
                  {
                    modulData['Diskussion'] ?
                      <IonCol key={Math.random()} sizeLg='6' size="6" sizeSm='12' sizeXs='12'>
                        <IonCard style={{ backgroundColor: "" }}>
                          <IonCardHeader>
                            <IonCardTitle><IonIcon icon={chatbubble}/>Diskussion</IonCardTitle>
                          </IonCardHeader>
                          <IonCardContent>
                              <p>{textformatierung(modulData['Diskussion'])}  </p>
                          </IonCardContent>
                        </IonCard>
                      </IonCol>
                      :
                      null
                  }
                  {
                    modulData['LICHTMOMENT'] ?
                      <IonCol key={Math.random()} sizeLg='6' size="6" sizeSm='12' sizeXs='12'>
                        <IonCard style={{ backgroundColor: "#E1D5EF" }}>
                          <IonCardHeader>
                            <IonCardTitle><IonImg src="logo_lichteMomente.png" style={{maxHeight:'35px',height:"35px"}}/>&nbsp;LICHTMOMENT</IonCardTitle>
                          </IonCardHeader>
                          <IonCardContent>
                              <p><b>{textformatierung(modulData['LICHTMOMENT'])}</b></p>
                          </IonCardContent>
                        </IonCard>
                      </IonCol>
                      :
                      null
                  }
                  {
                    modulData['MEDIEN'] ?
                      <IonCol key={Math.random()} sizeLg='6' size="6" sizeSm='12' sizeXs='12'>
                        <IonCard style={{ backgroundColor: "" }}>
                          <IonCardHeader>
                            <IonCardTitle><IonIcon icon={bookOutline} />&nbsp;Medien</IonCardTitle>
                          </IonCardHeader>
                          <IonCardContent>
                              <p>{textformatierung(modulData['MEDIEN'])}  </p>
                          </IonCardContent>
                        </IonCard>
                      </IonCol>
                      :
                      null
                  }
                  {
                    modulData['Antwort1'] ?
                      <IonCol key={Math.random()} sizeLg='6' size="6" sizeSm='12' sizeXs='12'>
                        <IonCard style={{ backgroundColor: "" }}>
                          <IonCardHeader>
                            <IonCardTitle><IonIcon icon={helpOutline} />&nbsp;Quizfragen</IonCardTitle>
                          </IonCardHeader>
                          <IonCardContent>
                            
                             {<Fragen modulData={modulData}/>}
                          </IonCardContent>
                        </IonCard>
                      </IonCol>
                      :
                      null
                  }
                  {
                    modulData['ZumgutenSchluss'] ?
                      <IonCol key={Math.random()} sizeLg='6' size="6" sizeSm='12' sizeXs='12'>
                        <IonCard style={{ backgroundColor: "" }}>
                          <IonCardHeader>
                            <IonCardTitle>Zum guten Schluss</IonCardTitle>
                          </IonCardHeader>
                          <IonCardContent>
                              <p>{textformatierung(modulData['ZumgutenSchluss'])}  </p>
                          </IonCardContent>
                        </IonCard>
                      </IonCol>
                      :
                      null
                  }
                  {
                    modulData['HiergibtesHilfe'] ?
                      <IonCol key={Math.random()} sizeLg='6' size="6" sizeSm='12' sizeXs='12'>
                        <IonCard style={{ backgroundColor: "" }}>
                          <IonCardHeader>
                            <IonCardTitle>Hier gibt es Hilfe</IonCardTitle>
                          </IonCardHeader>
                          <IonCardContent>
                              <p>{textformatierung(modulData['HiergibtesHilfe'])}  </p>
                          </IonCardContent>
                        </IonCard>
                      </IonCol>
                      :
                      null
                  }
                  {
                    modulData['Bild'] ?
                      <IonCol key={Math.random()} sizeLg='12' size="12" sizeSm='12' sizeXs='12'>
                        <IonCard style={{ backgroundColor: "" }}>
                         
                          <IonCardContent>
                            <IonImg src={String(modulData.Bild)}/>
                            <a href="https://www.gaymann.de/demensch/" rel="noreferrer" target="_blank">DEMENSCH - Peter Gaymann</a>
                          </IonCardContent>
                        </IonCard>
                      </IonCol>
                      :
                      null
                  }
                  {
                    modulData['Schlagworte'] ?
                      <IonCol key={Math.random()} sizeLg='6' size="12" sizeSm='12' sizeXs='12'>
                        <IonCard style={{ backgroundColor: "" }}>
                          <IonCardHeader>
                            <IonCardTitle>Schlagworte</IonCardTitle>
                          </IonCardHeader>
                          <IonCardContent>
                            {
                              modulData['Schlagworte'].split(' – ').map((schlagwort:any)=>{
                                return (
                                  <IonRouterLink  key={Math.random()} href={'/Schlagwort/'+schlagwort}><IonChip key={Math.random()} >{schlagwort}</IonChip></IonRouterLink>
                                )
                              })
                            }
                          </IonCardContent>
                        </IonCard>
                      </IonCol>
                      :
                      null
                  }
                   {
                    
                      <IonCol key={Math.random()} sizeLg='6' size="12" sizeSm='12' sizeXs='12'>
                        <IonCard style={{ backgroundColor: "" }}>
                          <IonCardHeader>
                            <IonCardTitle>Wie geht es weiter?</IonCardTitle>
                          </IonCardHeader>
                          <IonCardContent>
                              <p>{modulData['WIEGEHTESWEITER?'] ? textformatierung(modulData['WIEGEHTESWEITER?']):null}  </p>
                              <br />                     
                              {nextModulTitle ?  <IonButton routerLink={`/ModulDyn/${nextModulTitle}`}>zum nächsten Modul gehen</IonButton> : <IonButton routerLink= "/Modul/">zum Abschlußquiz gehen</IonButton>}
                              

                          </IonCardContent>
                        </IonCard>
                      </IonCol>
                   
                  }



        <IonCol sizeLg='6' size="6" sizeSm='12' sizeXs='12'>
                  <IonCard style={{ backgroundColor: "" }}>
                    </IonCard>
        </IonCol>
                
        </IonRow></IonGrid>

          :
          <IonText color="danger"><h2 style={{textAlign:'center'}}>Dieses Modul ist erst ab dem {gültigAbString} verfügbar.</h2></IonText>
        }
        
      </IonContent>
      </>

              )
            }
            else {
              return null;
            }
          })
        }
    </IonPage>
  );
};

export default ModulDyn;
